import { render, staticRenderFns } from "./seDetail.vue?vue&type=template&id=195c1db8&"
import script from "./seDetail.vue?vue&type=script&lang=js&"
export * from "./seDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('195c1db8')) {
      api.createRecord('195c1db8', component.options)
    } else {
      api.reload('195c1db8', component.options)
    }
    module.hot.accept("./seDetail.vue?vue&type=template&id=195c1db8&", function () {
      api.rerender('195c1db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/seDetail.vue"
export default component.exports